import { render, staticRenderFns } from "./ProgramSelect.vue?vue&type=template&id=b4a28932&"
import script from "./ProgramSelect.vue?vue&type=script&lang=js&"
export * from "./ProgramSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports